import type { ReactNode } from 'react';
import { CatalogQuantity } from './CatalogProductRow';
import { Money } from './components';
import { MobileSkuCard } from './MobileSkuCard';
import type { Product, Sku } from './types';

export function MobileSkuList({ products, quantityForSku, onQuantity, canOrder, disabled, renderPrice, renderSubtotal }: {
  products: Product[];
  quantityForSku: (sku: Sku) => number;
  onQuantity: (product: Product, sku: Sku, quantity: number) => void;
  canOrder: boolean;
  disabled: boolean | ((sku: Sku) => boolean);
  renderPrice: (sku: Sku) => ReactNode;
  renderSubtotal?: (sku: Sku, quantity: number) => ReactNode;
}) {
  return <section className="mobile-sku-list" aria-label="当前分类规格">
    {products.flatMap(product => product.skus.map(sku => {
      const quantity = quantityForSku(sku);
      const name = sku.productName || product.name;
      const code = sku.productCode || product.code;
      return <MobileSkuCard key={sku.id} productId={sku.productId || product.id} imageUrl={sku.imageUrl || product.imageUrl}
        code={code} name={name} specification={sku.specification} unit={sku.unit} skuCode={sku.code} selected={quantity > 0}>
        <div className="mobile-sku__order">{renderPrice(sku)}
          {canOrder && <CatalogQuantity value={quantity} unit={sku.unit} label={`${name}（${sku.code}）订购数量，单位${sku.unit}`} disabled={typeof disabled === 'function' ? disabled(sku) : disabled}
            onChange={value => onQuantity(product, sku, value)} />}
        </div>
        {canOrder && quantity > 0 && <p className="mobile-sku__subtotal">已选 {quantity} {sku.unit}<span>小计 {renderSubtotal ? renderSubtotal(sku, quantity) : <Money cents={sku.priceCents * quantity} />}</span></p>}
      </MobileSkuCard>;
    }))}
  </section>;
}
